import React, { useEffect, useState } from 'react';

import './index.scss';
import { Link } from 'react-router-dom';

function ContentMenu({ menuItems, selected }) {
  const [current, setCurrent] = useState(selected);

  const selectedChanged = (e) => {
    const val = e.target ? e.target.value : e;
    document.getElementById(val).scrollIntoView({ behavior: 'smooth', block: 'start' });
    setCurrent(val);
  };

  useEffect(() => {
    document.getElementById(selected).scrollIntoView({ behavior: 'smooth', block: 'start' });
    setCurrent(selected);
  }, [selected]);

  return (
    <div className="solutions-content-menu">
      {
        menuItems.map(item =>
          <Link to={'/' + item.path} onClick={() => selectedChanged(item.slug)}
          >
            <div className="solutions-content-menu-inner" key={item.slug}>
              <input
                id={item.slug + 'contentMenuITem'}
                type="radio" name="item" value={item.slug}
                className="hidden"
                onChange={selectedChanged}
              />
              <label htmlFor={item.slug + 'contentMenuITem'}
                     className={item.slug === current ? 'text-selected' : ''}>{item.name}</label>
            </div>
          </Link>
        )
      }
    </div>
  );
}

export default ContentMenu;
